import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Gelerycards from "./Gelerycards";
import Banquethallmodel from "./Banquethallmodel";

// Banquet Hall Images import
import hall1 from "./Cloudimages/banquet.jpg";
import hall2 from "./Cloudimages/banqet2.jpg";
import hall3 from "./Cloudimages/banquet3.jpg";
import hall4 from "./Cloudimages/banquethall.webp";

const BanquetHallBanner = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <>
      <style>{`
        /* Banquet Hall Banner Styles */

        .banquet-banner-top {
          text-align: center;
          margin-bottom: 30px;
          margin-top: -40px;
          max-width: 1017px;
          margin-left: auto;
          margin-right: auto;
        }

        .banquet-banner-top h1 {
          font-size: 3rem;
          font-weight: bold;
          line-height: 1.2;
          margin-bottom: 15px;
          color: #333;
        }

        .banquet-banner-top p {
          font-size: 1.1rem;
          line-height: 1.6;
          margin-bottom: 20px;
          color: #666;
        }

        /* Slider Section */
        .banquet-banner-slider {
          width: 100%;
          max-width: 1000px;
          margin: 0 auto;
        }

        .banquet-slide {
          position: relative;
          height: 420px;
        }

        .banquet-slide img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 14px;
        }

        .banquet-slide-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.45);
          border-radius: 14px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          color: #fff;
          padding: 20px;
        }

        .banquet-slide-overlay h2 {
          font-size: 2rem;
          margin-bottom: 12px;
        }

        .banquet-slide-overlay p {
          font-size: 1rem;
          max-width: 650px;
        }

        /* Responsive */
        @media (max-width: 1024px) {
          .banquet-banner-top h1 {
            font-size: 2.4rem;
          }
          .banquet-slide {
            height: 320px;
          }
        }

        @media (max-width: 600px) {
          .banquet-banner-top h1 {
            font-size: 1.9rem;
          }
          .banquet-banner-top p {
            font-size: 0.95rem;
          }
          .banquet-slide {
            height: 220px;
          }
          .banquet-slide-overlay h2 {
            font-size: 1.3rem;
          }
          .banquet-slide-overlay p {
            font-size: 0.85rem;
          }
        }
      `}</style>

      {/* Banner Text Section */}


      {/* Slider Section */}
      <div className="banquet-banner-slider">
        <Slider {...settings}>
          <div className="banquet-slide">
            <img src={hall1} alt="Banquet Hall 1" />
            <div className="banquet-slide-overlay">
              <h2>Spacious Venues</h2>
              <p>Celebrate with your guests in our large and beautifully decorated banquet spaces.</p>
            </div>
          </div>
          <div className="banquet-slide">
            <img src={hall2} alt="Banquet Hall 2" />
            <div className="banquet-slide-overlay">
              <h2>Elegant Interiors</h2>
              <p>Experience premium décor and a luxurious atmosphere for every occasion.</p>
            </div>
          </div>
          <div className="banquet-slide">
            <img src={hall3} alt="Banquet Hall 3" />
            <div className="banquet-slide-overlay">
              <h2>Catering Excellence</h2>
              <p>Enjoy gourmet menus tailored to your events with top-class catering services.</p>
            </div>
          </div>
          <div className="banquet-slide">
            <img src={hall4} alt="Banquet Hall 4" />
            <div className="banquet-slide-overlay">
              <h2>Memorable Events</h2>
              <p>Make your weddings, receptions, and parties unforgettable with our expert event planning.</p>
            </div>
          </div>
        </Slider>
      </div>

      {/* Other Components Below */}
      <div style={{ marginTop: "25px" }}>
        <Gelerycards />
      </div>
      <div style={{ marginTop: "25px" }}>
        <Banquethallmodel />
      </div>
    </>
  );
};

export default BanquetHallBanner;
